import Navbar from './components/Navbar';
import SectionDivider from './components/SectionDivider';
import HeroSection from './components/HeroSection';
import ProjectOverview from './components/ProjectOverview';
import ProjectBackground from './components/ProjectBackground';
import VisionPolicyIntersection from './components/VisionPolicyIntersection';
import WhoItServes from './components/WhoItServes';
import WhatMakesDifferent from './components/WhatMakesDifferent';
import CoreSpaces from './components/CoreSpaces';
import ProgramsServices from './components/ProgramsServices';
import VisionMission from './components/VisionMission';
import TargetAudience from './components/TargetAudience';
import OperatingModel from './components/OperatingModel';
import YouthImpact from './components/YouthImpact';
import StakeholderImpact from './components/StakeholderImpact';
import Benchmarking from './components/Benchmarking';
import KPIs from './components/KPIs';
import RiskManagement from './components/RiskManagement';
import Sustainability from './components/Sustainability';
import FinancialFeasibility from './components/FinancialFeasibility';
import PartnershipCall from './components/PartnershipCall';
import Partners from './components/Partners';
import MediaSection from './components/MediaSection';
import GlobalModelsAppendix from './components/GlobalModelsAppendix';
import PartnershipCTA from './components/PartnershipCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Bar */}
      <Navbar />
      
      {/* Hero Section - No ID needed as it's at the top */}
      <div className="relative">
        <HeroSection />
        {/* Wave Transition */}
        <div className="absolute bottom-0 left-0 right-0 -mb-1">
          <SectionDivider variant="wave" />
        </div>
      </div>

      {/* Overview Section */}
      <div id="overview" className="bg-white shadow-sm">
        <ProjectOverview />
      </div>

      {/* About Section */}
      <div id="about" className="bg-gradient-to-b from-white to-[#FFF5F3]">
        <SectionDivider variant="icon" icon="ri-book-open-line" />
        <ProjectBackground />
        <SectionDivider variant="gradient" />
        <VisionPolicyIntersection />
        <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent my-8"></div>
        <WhoItServes />
        <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent my-8"></div>
        <WhatMakesDifferent />
      </div>

      {/* Spaces Section */}
      <div id="spaces" className="bg-white">
        <SectionDivider variant="geometric" />
        <CoreSpaces />
        <ProgramsServices />
        <SectionDivider variant="dots" />
        <VisionMission />
        <SectionDivider variant="gradient" />
        <TargetAudience />
      </div>

      {/* Impact Section */}
      <div id="impact" className="bg-gradient-to-br from-gray-50 via-white to-gray-50 shadow-inner">
        <SectionDivider variant="icon" icon="ri-line-chart-line" />
        <OperatingModel />
        <SectionDivider variant="gradient" />
        <YouthImpact />
        <SectionDivider variant="icon" icon="ri-building-line" />
        <StakeholderImpact />
        <SectionDivider variant="dots" />
        <Benchmarking />
      </div>

      {/* KPIs Section */}
      <div id="kpis" className="bg-white">
        <SectionDivider variant="gradient" />
        <KPIs />
        <div className="py-8">
          <div className="container mx-auto px-6">
            <div className="h-px bg-gradient-to-r from-transparent via-[#FF6B6B]/30 to-transparent"></div>
          </div>
        </div>
        <RiskManagement />
        <SectionDivider variant="dots" />
        <Sustainability />
      </div>

      {/* Financial Section */}
      <div id="financial" className="bg-gradient-to-b from-white to-[#FFF5F3] shadow-sm">
        <SectionDivider variant="icon" icon="ri-money-dollar-circle-line" />
        <FinancialFeasibility />
      </div>

      {/* Partnership Section */}
      <div id="partnership" className="bg-white">
        <SectionDivider variant="wave" />
        <PartnershipCall />
        <SectionDivider variant="dots" />
        <Partners />
        <SectionDivider variant="gradient" />
        <MediaSection />
        <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent my-8"></div>
        <GlobalModelsAppendix />
      </div>

      {/* Final CTA and Footer */}
      <SectionDivider variant="geometric" />
      <PartnershipCTA />
      <Footer />
    </div>
  );
}
